import { Button, ButtonProps } from '@mui/material';
import { NavigateFunction, To, useNavigate } from 'react-router-dom';
import { SxProps } from '@mui/system';
import { Theme } from '@mui/material/styles';
import React, { FC, ReactElement } from 'react';

export interface ButtonLinkProps extends ButtonProps {
  to?: To;
  state?: unknown;
  noHover?: boolean;
}

export const ButtonLink: FC<ButtonLinkProps> = (props: ButtonLinkProps): ReactElement => {
  const { children, to, noHover, state, ...other } = props;

  const navigate: NavigateFunction = useNavigate();

  const noHoverSx: SxProps<Theme> = noHover
    ? {
        '&:hover': {
          background: 'none',
        },
      }
    : {};

  return (
    <Button
      color={'inherit'}
      variant={'text'}
      sx={{
        p: props.size === 'small' ? '10px' : '12px',
        m: props.size === 'small' ? '-10px' : '-12px',
        ...noHoverSx,
      }}
      onClick={(): void => {
        if (to) {
          navigate(to, { state: state });
        }
      }}
      disableRipple={!!noHover}
      {...other}>
      {children}
    </Button>
  );
};
